import { render, staticRenderFns } from "./ShippingAddress.vue?vue&type=template&id=74b422a8&scoped=true"
import script from "./ShippingAddress.vue?vue&type=script&lang=js"
export * from "./ShippingAddress.vue?vue&type=script&lang=js"
import style0 from "./ShippingAddress.vue?vue&type=style&index=0&id=74b422a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b422a8",
  null
  
)

export default component.exports